import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { TEvent as Event } from '../types';

const QUERY_KEY = 'events';

export const getEvents = (organizerId: number): Promise<Event[]> => {
  return axios.get(`/event/all/${organizerId}`);
};

type QueryFnType = typeof getEvents;

type UseEventOption = {
  organizerId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useEvents = ({ config, organizerId }: UseEventOption) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [QUERY_KEY, organizerId],
    queryFn: () => getEvents(organizerId),
    ...config,
  });
};
